export enum FaiTabsEnum { // also used as url hash
    SMART_TV_GAMING = 'smart',
    PURE_BYOU = 'purebyou',
    BOX_INTERNET = 'box-internet',
    BOX_5G = '5gbox',
}
